import script from "./MyAccountNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountNav.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountNav.vue?vue&type=style&index=0&id=2d95e2de&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d95e2de"]])

export default __exports__